export const BRAND_COMPANY_NAME = process.env.REACT_APP_APP_BRAND_COMPANY_NAME
